// Waveform glyph + "tuned" wordmark (UX02). Owner: WP04.
export function Logo({ size = 28, wordmark = true }: { size?: number; wordmark?: boolean }) {
  const bars = [[2, 10, 8], [7, 5, 18], [12, 1, 26], [17, 7, 14], [22, 4, 20]]; // x, y, height on a 26×28 grid
  return (
    <span className="ui-logo" style={{ fontSize: size * 0.85 }}>
      <svg width={size * 0.93} height={size} viewBox="0 0 26 28" aria-hidden focusable="false">
        {bars.map(([x, y, h]) => <rect key={x} x={x} y={y} width="3" height={h} rx="1.5" fill="var(--accent)" />)}
      </svg>
      {wordmark ? <span className="ui-logo__word">tuned</span> : <span className="visually-hidden">Tuned</span>}
    </span>
  );
}
